/** @jsx onetext.jsx.element */

import type { OneText } from '../../../global';

// eslint-disable-next-line no-restricted-syntax
import { FireBellyLogo } from '../images';

declare let onetext : OneText;

export const BrandLogo = () : JSX.Element => {
    return (
        <div className={ 'w-[200px] h-8 mb-4' }>
            <img
                src={ FireBellyLogo }
                className={
                    'object-contain w-full h-full'
                } />

        </div>
    );
};
